<template>
  <div>
    <div class="bg">
      <div class="flex item-center flex-end">
        <div class="flex item-center flex-wrap flex-end" style="max-width: 1512px">
          <el-date-picker
              v-model="searchCondition.date"
              type="datetimerange"
              size="small"
              class="ml10 mb10"
              align="right"
              style="width: 422px"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
          <treeselect
              :multiple="true"
              :options="options"
              :limit="2"
              class="ml10 mb10"
              style="width: 422px"
              :limitText="count => `+${count}`"
              :load-options="loadOptions"
              placeholder="请选择销售品类"
              v-model="searchCondition.categoryIdList"
          />
          <el-select
              clearable
              v-model="searchCondition.orderSourceType"
              placeholder="请选择订单类型"
              size="small"
              style="width: 206px"
              filterable
              class="ml10 mb10"
          >
            <el-option label="线上" value="hemiao"></el-option>
            <el-option label="线下" value="erp"></el-option>
          </el-select>
          <el-select
              clearable
              v-model="searchCondition.shopid"
              placeholder="请选择销售门店"
              style="width: 206px"
              size="small"
              filterable
              class="ml10 mb10"
          >
            <el-option v-for="(v, i) in shopList" :key="i" :label="v.shopname" :value="v.shopid"></el-option>
          </el-select>
          <el-select
              clearable
              v-model="searchCondition.workNum"
              placeholder="请选择销售导购"
              size="small"
              style="width: 206px"
              :filter-method="filterGuider"
              filterable
              class="ml10 mb10"
          >
            <el-option v-for="(v, i) in guiderList" :key="i" :label="v.fullname" :value="v.usercode"></el-option>
          </el-select>
          <el-select
              clearable
              v-model="searchCondition.brandId"
              placeholder="请选择销售品牌"
              size="small"
              style="width: 206px"
              :filter-method="filterBrand"
              filterable
              class="ml10 mb10"
          >
            <el-option v-for="(v, i) in brandList" :key="i" :label="v.fullname" :value="v.typeid"></el-option>
          </el-select>

          <el-input
              clearable
              v-model.trim="searchCondition.receiptSn"
              placeholder="请输入订单号"
              size="small"
              style="width: 206px"
              class="ipt ml10 mb10"
          ></el-input>
          <el-input
              clearable
              v-model.trim="searchCondition.goodsSn"
              placeholder="请输入商品货号"
              size="small"
              style="width: 206px"
              class="ipt ml10 mb10"
          ></el-input>
          <div class="flex flex-1 item-center flex-end">
            <el-button type="primary" size="small" @click="search"
            >查询</el-button
            >
            <el-button
                type="success"
                size="small"
                @click="output"
                :loading="isOutputing"
            >导出</el-button
            >
            <el-button type="primary" size="small" @click="doConfigActuallyPaymentAmount"
            >展示配置项</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <hm-content class="mt10">
      <div class="mt20">
        <hm-custom-table
            :table-headers="tableHeaders"
            :mergeLabelList="mergeLabelList"
            :tableData="list"
            showRecount
            @recount="recount"
            @getSummaries="getSummaries" />
<!--        <el-table
            :data="list"
            stripe
            :max-height="tableHeight"
            :span-method="objectSpanMethod"
            :summary-method="getSummaries"
            show-summary
            size="small"
            row-key="id"
            ref="table"
            :row-style="{ height: '40px' }"
            :cell-style="{padding:'0px'}"
            border
        >
          <el-table-column
              header-align="center"
              align="center"
              prop="nosort"
              label="序号"
              width="50"
              key="nosort"
              fixed="left"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="序号" placement="top" effect="dark">
                <span class="table-header-wrapper">序号</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              prop="receiptSn"
              label="订单号"
              header-align="center"
              align="center"
              width="160"
              fixed="left"
              key="receiptSn"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="订单号" placement="top" effect="dark">
                <span class="table-header-wrapper">订单号</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              prop="orderSourceType"
              label="订单类型"
              header-align="center"
              align="center"
              width="80"
              key="orderSourceType"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="订单类型" placement="top" effect="dark">
                <span class="table-header-wrapper">订单类型</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.orderSourceType == 'erp'">线下</span>
              <span v-if="scope.row.orderSourceType == 'hemiao'">线上</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="saleDate"
              label="销售时间"
              header-align="center"
              align="center"
              width="140"
              key="saleDate"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="销售时间" placement="top" effect="dark">
                <span class="table-header-wrapper">销售时间</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              prop="goodsType"
              label="销售类型"
              header-align="center"
              align="center"
              width="80"
              key="goodsType"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="销售类型" placement="top" effect="dark">
                <span class="table-header-wrapper">销售类型</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span >{{ scope.row.goodsType == 'gift' ? "赠品" : "销售"}}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="goodsName"
              label="商品名称"
              header-align="center"
              align="center"
              width="180"
              key="goodsName"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="商品名称" placement="top" effect="dark">
                <span class="table-header-wrapper">商品名称</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              prop="erpColorName"
              label="颜色尺码"
              header-align="center"
              align="center"
              width="80"
              key="erpColorName"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="颜色尺码" placement="top" effect="dark">
                <span class="table-header-wrapper">颜色尺码</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
            <span v-if="scope.row.erpColorName && scope.row.erpSizeName">
              {{ scope.row.erpColorName + "," + scope.row.erpSizeName }}
            </span>
              <span v-else-if="scope.row.erpColorName">
              {{ scope.row.erpColorName }}
            </span>
              <span v-else-if="scope.row.erpSizeName">
              {{ scope.row.erpSizeName }}
            </span>
            </template>
          </el-table-column>
          <el-table-column
              prop="goodsSn"
              label="商品货号"
              header-align="center"
              align="center"
              width="80"
              key="goodsSn"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="商品货号" placement="top" effect="dark">
                <span class="table-header-wrapper">商品货号</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              prop="erpCategoryFullName"
              label="商品品类"
              header-align="center"
              align="center"
              width="130"
              key="erpCategoryFullName"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="商品品类" placement="top" effect="dark">
                <span class="table-header-wrapper">商品品类</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              prop="erpBrandName"
              label="商品品牌"
              header-align="center"
              align="center"
              width="80"
              key="erpBrandName"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="商品品牌" placement="top" effect="dark">
                <span class="table-header-wrapper">商品品牌</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              prop="pmTypeDetailPosShow"
              label="促销方式"
              header-align="center"
              align="center"
              width="80"
              key="pmTypeDetailPosShow"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="促销方式" placement="top" effect="dark">
                <span class="table-header-wrapper">促销方式</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              prop="pmNameDetailPosShow"
              label="促销名称"
              header-align="center"
              align="center"
              width="80"
              key="pmNameDetailPosShow"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="促销名称" placement="top" effect="dark">
                <span class="table-header-wrapper">促销名称</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              prop="goodsNum"
              label="商品数量"
              header-align="center"
              align="center"
              width="80"
              key="goodsNum"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="商品数量" placement="top" effect="dark">
                <span class="table-header-wrapper">商品数量</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              prop="retailPrice"
              label="零售价"
              header-align="center"
              align="center"
              width="80"
              key="retailPrice"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="零售价:单个商品的零售价格" placement="top" effect="dark">
                <span class="table-header-wrapper">零售价</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              {{ ToFixed(scope.row.retailPrice, 2) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="retailAmount"
              label="零售额"
              header-align="center"
              align="center"
              width="80"
              key="retailAmount"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="零售额:商品数量*零售价" placement="top" effect="dark">
                <span class="table-header-wrapper">零售额</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              {{ ToFixed(scope.row.retailAmount, 2) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="pmDivideDetailPosShow"
              label="促销优惠"
              header-align="center"
              align="center"
              width="80"
              key="pmDivideDetailPosShow"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="促销优惠:参与各种活动所优惠的价格" placement="top" effect="dark">
                <span class="table-header-wrapper">促销优惠</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span class="primary" >{{ ToFixed(scope.row.pmDivideAmount || 0, 2) }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="memberpriceDivideDetailPosShow"
              label="会员优惠"
              header-align="center"
              align="center"
              width="80"
              key="memberpriceDivideDetailPosShow"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="会员优惠" placement="top" effect="dark">
                <span class="table-header-wrapper">会员优惠</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span class="primary" >{{ ToFixed(scope.row.memberDivideAmountTotal || 0, 2) }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="prepayDivideDetailPosShow"
              label="优惠券抵扣"
              header-align="center"
              align="center"
              width="90"
              key="prepayDivideDetailPosShow"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="优惠券抵扣:" placement="top" effect="dark">
                <span class="table-header-wrapper">优惠券抵扣</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span class="primary" >{{ ToFixed(scope.row.couponDivideAmount || 0, 2) }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="changePriceAmount"
              label="改价优惠"
              header-align="center"
              align="center"
              width="90"
              key="changePriceAmount"
          >
            <template slot="header">
              <el-tooltip content="改价优惠:" placement="top" effect="dark">
                <span class="table-header-wrapper">改价优惠</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.showTip" placement="top" effect="dark">
                <span class="table-header-wrapper primary">{{ ToFixed(scope.row.changePriceAmount || 0, 2) }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              prop="payPrice"
              label="成交单价"
              header-align="center"
              align="center"
              width="80"
              key="payPrice"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="成交单价" placement="top" effect="dark">
                <span class="table-header-wrapper">成交单价</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              {{ ToFixed(scope.row.payNoCouponPrice, 2) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="payAmount"
              label="成交金额"
              header-align="center"
              align="center"
              width="80"
              key="payAmount"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="成交金额" placement="top" effect="dark">
                <span class="table-header-wrapper">成交金额</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              {{ ToFixed(scope.row.payNoCouponAmount, 2) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="orderRetailAmount"
              label="订单原价"
              header-align="center"
              align="center"
              width="80"
              key="orderRetailAmount"
              v-if="showOrderInfo"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="订单原价" placement="top" effect="dark">
                <span class="table-header-wrapper">订单原价</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              {{ ToFixed(scope.row.orderRetailAmount, 2) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="totalPrepayDivideAmount"
              label="储值卡支付"
              header-align="center"
              align="center"
              width="90"
              key="totalPrepayDivideAmount"
              v-if="showOrderInfo"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="储值卡支付" placement="top" effect="dark">
                <span class="table-header-wrapper">储值卡支付</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              {{ ToFixed(scope.row.totalPrepayDivideAmount, 2) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="totalGoldbeanDividDivideAmount"
              label="金豆支付"
              header-align="center"
              align="center"
              v-if="showOrderInfo"
              width="80"
              key="totalGoldbeanDividDivideAmount"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="金豆支付" placement="top" effect="dark">
                <span class="table-header-wrapper">金豆支付</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              {{ ToFixed(scope.row.totalGoldbeanDividDivideAmount, 2) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="totalActuallyPaymentAmount"
              label="实付金额"
              header-align="center"
              align="center"
              width="80"
              v-if="showOrderInfo"
              key="totalActuallyPaymentAmount"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="实付金额" placement="top" effect="dark">
                <span class="table-header-wrapper">实付金额</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              {{ ToFixed(scope.row.totalActuallyPaymentAmount, 2) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="roundDownAmount"
              label="抹零"
              header-align="center"
              align="center"
              width="80"
              key="roundDownAmount"
              v-if="showOrderInfo"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="抹零" placement="top" effect="dark">
                <span class="table-header-wrapper">抹零</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              {{ ToFixed(scope.row.roundDownAmount, 2) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="orderPayAmount"
              label="订单成交金额"
              header-align="center"
              align="center"
              v-if="showOrderInfo"
              width="100"
              key="orderPayAmount"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="订单成交金额" placement="top" effect="dark">
                <span class="table-header-wrapper">订单成交金额</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              {{ ToFixed(scope.row.orderPayAmount, 2) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="erpShopName"
              label="销售门店"
              header-align="center"
              align="center"
              width="180"
              key="erpShopName"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="销售门店" placement="top" effect="dark">
                <span class="table-header-wrapper">销售门店</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              prop="erpGuiderName"
              label="销售导购"
              header-align="center"
              align="center"
              width="120"
              key="erpGuiderName"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="销售导购" placement="top" effect="dark">
                <span class="table-header-wrapper">销售导购</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="orderSn"
              label="操作"
              width="80"
              fixed="right"
              key="cz"
              show-overflow-tooltip
          >
            <template slot="header">
              <el-tooltip content="操作" placement="top" effect="dark">
                <span class="table-header-wrapper">操作</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-button size="small" type="text" @click="recount(scope.row)"
                >重新计算</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>-->
      </div>
      <div class="hm-pagination mt20">
        <el-pagination
            background
            :total="total"
            @current-change="paging"
            :current-page="currentPage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 50, 100, 200]"
            layout="total, sizes,  prev, pager, next, jumper"
        ></el-pagination>
      </div>

      <div v-if="actuallyPaymentAmountConfigShow">
        <actually-payment-amount-config
            :show="actuallyPaymentAmountConfigShow"
            :table-headers="allTableHeaders"
            :selected-table-headers="tableHeaders"
            :disabled-table-headers="disabledTableHeaders"
            :storeCode="storeCode"
            :dataType="'gjp'"
            @closeConfigShow="closeConfigShow" />
      </div>
    </hm-content>
  </div>

</template>

<script>
import moment from "moment";
import {mapState,mapGetters} from "vuex";
import {getLoginUser} from "@/utils/auth";
import { ToFixed } from "@/utils/utils";
import ActuallyPaymentAmountConfig from "@/components/actuallyPaymentAmountConfig";
import HmCustomTable from "@/components/HmCustomTable";

import { LOAD_CHILDREN_OPTIONS, LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect';
import axios from "axios";

// We just use `setTimeout()` here to simulate an async operation
// instead of requesting a real API server for demo purpose.
const simulateAsyncOperation = fn => {
  setTimeout(fn, 2000)
}
export default {
  components: {ActuallyPaymentAmountConfig, HmCustomTable},
  data() {
    return {
      ToFixed,
      moment,
      storeCode: "",
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        date: [
            moment(new Date()).add(-1, "days").format("YYYY-MM-DD") + " 00:00:00",
            moment(new Date()).add(-1, "days").format("YYYY-MM-DD") + " 23:59:59",
        ],
        shopid: "",
        workNum: "",
        brandId: "",
        receiptSn: "",
        goodsSn: "",
        categoryIdList: [],
        orderSourceType: ""
      },
      shopList: [],
      guiderList: [],
      allGuiderList: [],
      brandList: [],
      AllBrandList: [],
      allRecords: [],
      categoryFunc: {
        checkStrictly: true,
        multiple: true,
        lazy: true,
        emitPath: false,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
                .dispatch("queryGjpCategoryTree", {
                  parentCategoryId: "00000",
                  storeCode: this.storeCode
                })
                .then(res => {
                  res.result.forEach(v => {
                    v.value = v.typeid;
                    v.label = v.fullname;
                  });
                  resolve(res.result);
                });
          } else {
            this.$store
                .dispatch("queryGjpCategoryTree", {
                  storeCode: this.storeCode,
                  parentCategoryId: data.typeid
                })
                .then(res => {
                  this.level = level + 1;
                  if (res.code === 200 && res.result.length) {
                    res.result.forEach(v => {
                      v.value = v.typeid;
                      v.label = v.fullname;
                    });
                    resolve(res.result);
                  } else {
                    resolve([]);
                  }
                });
          }
        }
      },
      mergeLabelList: ["序号", "订单号", "订单类型", "销售时间", "销售门店", "订单原价", "订单成交金额", "储值卡支付", "金豆支付", "实付金额", "抹零", "操作"],
      tableHeight: 500,
      sums: [],
      summartResult: {},
      showOrderInfo: true,
      footerTr: "",
      actuallyPaymentAmountConfigShow: false,
      isOutputing: false,
      tableHeaders: [],
      allTableHeaders: [
        {
          prop: "nosort",
          label: "序号",
          fixedFlag: true,
          fixed: "left",
          tipContent: "序号",
          width: 50,
          valueType: "string",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "receiptSn",
          label: "订单号",
          fixedFlag: true,
          fixed: "left",
          tipContent: "订单号",
          width: 160,
          valueType: "string",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "orderSourceType",
          label: "订单类型",
          fixedFlag: true,
          fixed: "left",
          tipContent: "订单类型",
          width: 80,
          valueType: "string",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "saleDate",
          label: "销售时间",
          fixedFlag: false,
          fixed: "",
          tipContent: "销售时间",
          width: 140,
          valueType: "string",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "goodsType",
          label: "销售类型",
          fixedFlag: false,
          fixed: "",
          tipContent: "销售类型",
          width: 80,
          valueType: "string",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "goodsName",
          label: "商品名称",
          fixedFlag: false,
          fixed: "",
          tipContent: "商品名称",
          width: 180,
          valueType: "string",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "erpColorName",
          label: "颜色尺码",
          fixedFlag: false,
          fixed: "",
          tipContent: "颜色尺码",
          width: 80,
          valueType: "string",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "goodsSn",
          label: "商品货号",
          fixedFlag: false,
          fixed: "",
          tipContent: "商品货号",
          width: 80,
          valueType: "string",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "erpCategoryFullName",
          label: "商品品类",
          fixedFlag: false,
          fixed: "",
          tipContent: "商品品类",
          width: 130,
          valueType: "string",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "erpBrandName",
          label: "商品品牌",
          fixedFlag: false,
          fixed: "",
          tipContent: "商品品牌",
          width: 80,
          valueType: "string",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "pmTypeDetailPosShow",
          label: "促销方式",
          fixedFlag: false,
          fixed: "",
          tipContent: "促销方式",
          width: 80,
          valueType: "string",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "pmNameDetailPosShow",
          label: "促销名称",
          fixedFlag: false,
          fixed: "",
          tipContent: "促销名称",
          width: 80,
          valueType: "string",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "goodsNum",
          label: "商品数量",
          fixedFlag: false,
          fixed: "",
          tipContent: "商品数量",
          width: 80,
          valueType: "number",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "retailPrice",
          label: "零售价",
          fixedFlag: false,
          fixed: "",
          tipContent: "零售价:单个商品的零售价格",
          width: 80,
          valueType: "money",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "retailAmount",
          label: "零售额",
          fixedFlag: false,
          fixed: "",
          tipContent: "零售额:商品数量*零售价",
          width: 80,
          valueType: "money",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "pmDivideAmount",
          label: "促销优惠",
          fixedFlag: false,
          fixed: "",
          tipContent: "促销优惠:参与各种活动所优惠的价格",
          width: 80,
          valueType: "money",
          showTipFlag: true,
          valueColor: "#E60E6D"
        },
        {
          prop: "memberDivideAmountTotal",
          label: "会员优惠",
          fixedFlag: false,
          fixed: "",
          tipContent: "会员优惠",
          width: 80,
          valueType: "money",
          showTipFlag: true,
          valueColor: "#E60E6D"
        },
        {
          prop: "couponDivideAmount",
          label: "优惠券抵扣",
          fixedFlag: false,
          fixed: "",
          tipContent: "优惠券抵扣",
          width: 90,
          valueType: "money",
          showTipFlag: true,
          valueColor: "#E60E6D"
        },
        {
          prop: "changePriceAmount",
          label: "改价优惠",
          fixedFlag: false,
          fixed: "",
          tipContent: "改价优惠",
          width: 80,
          valueType: "money",
          showTipFlag: false,
          valueColor: "#E60E6D"
        },
        {
          prop: "payNoCouponPrice",
          label: "成交单价",
          fixedFlag: false,
          fixed: "",
          tipContent: "成交单价",
          width: 80,
          valueType: "money",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "payNoCouponAmount",
          label: "成交金额",
          fixedFlag: false,
          fixed: "",
          tipContent: "成交金额",
          width: 80,
          valueType: "money",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "orderRetailAmount",
          label: "订单原价",
          fixedFlag: false,
          fixed: "",
          tipContent: "订单原价",
          width: 80,
          valueType: "money",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "totalPrepayDivideAmount",
          label: "储值卡支付",
          fixedFlag: false,
          fixed: "",
          tipContent: "储值卡支付",
          width: 90,
          valueType: "money",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "totalGoldbeanDividDivideAmount",
          label: "金豆支付",
          fixedFlag: false,
          fixed: "",
          tipContent: "金豆支付",
          width: 80,
          valueType: "money",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "totalActuallyPaymentAmount",
          label: "实付金额",
          fixedFlag: false,
          fixed: "",
          tipContent: "实付金额",
          width: 80,
          valueType: "money",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "roundDownAmount",
          label: "抹零",
          fixedFlag: false,
          fixed: "",
          tipContent: "抹零",
          width: 80,
          valueType: "money",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "orderPayAmount",
          label: "订单成交金额",
          fixedFlag: false,
          fixed: "",
          tipContent: "订单成交金额",
          width: 100,
          valueType: "money",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "erpShopName",
          label: "销售门店",
          fixedFlag: false,
          fixed: "",
          tipContent: "销售门店",
          width: 180,
          valueType: "string",
          showTipFlag: true,
          valueColor: ""
        },
        {
          prop: "erpGuiderName",
          label: "销售导购",
          fixedFlag: false,
          fixed: "",
          tipContent: "销售导购",
          width: 180,
          valueType: "string",
          showTipFlag: true,
          valueColor: ""
        }
      ],
      options: null,
      disabledTableHeaders: ["nosort", "receiptSn"],
    };
  },
  computed: mapState({
    querySearchCondition: state => state.rules.querySearchCondition
  }),
  created() {
    const { storeCode } = getLoginUser();
    // let storeCode = "36040016092873";
    if (storeCode) {
      this.storeCode = storeCode;
    }
  },
  mounted() {
    this.tableHeaders = this.allTableHeaders;
    // this.setHeight();
    if (this.storeCode) {
      // this.queryList();
      this.queryShopList();
      this.queryGjpBrandList();
      this.queryGjpGuiderList();
      // this.clacGjpPosOrderDivideSummary();
    }
  },
  activated() {
    console.log("this.querySearchCondition:",this.querySearchCondition)
    if(JSON.stringify(this.querySearchCondition)!='{}'){
      this.searchCondition = this.querySearchCondition;
      this.search();
    }
  },
  methods: {
    saveFile(filePath) {
      let temp = filePath.split("/");
      this.row = {
        fileName: temp[temp.length - 1]
      };
      axios({
        method: "post",
        url:
            this.$serverAdress +
            `/sys/common/download?filePath=${filePath}`,
        responseType: "arraybuffer"
      }).then(res => {
        this.download(res.data);
      });
    },
    download(data) {
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", this.row.fileName);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url); //释放掉blob对象
    },
    async loadOptions({ action, parentNode, callback }) {
      console.log("action", action);
      console.log("LOAD_CHILDREN_OPTIONS", LOAD_CHILDREN_OPTIONS);
      console.log("parentNode", parentNode);

      if (action === LOAD_ROOT_OPTIONS) {
        this.$store
            .dispatch("queryGjpCategoryTree", {
              parentCategoryId: "00000",
              storeCode: this.storeCode
            })
            .then(res => {
              this.options = res.result.map(v => {
                return {
                  id: v.typeid,
                  label: v.fullname,
                  children: null,
                }
              });
            });
      }

      if (action === LOAD_CHILDREN_OPTIONS) {
        this.$store
            .dispatch("queryGjpCategoryTree", {
              storeCode: this.storeCode,
              parentCategoryId: parentNode.id
            })
            .then(res => {
              // this.level = level + 1;
              if (res.code === 200 && res.result.length) {
                parentNode.children = res.result.map(v => {
                  if (v.soncount && v.soncount > 0) {
                    return {
                      id: v.typeid,
                      label: v.fullname,
                      children: null,
                    }
                  } else {
                    return {
                      id: v.typeid,
                      label: v.fullname,
                    }
                  }
                });
                callback();
              } else {
                callback();
              }
            });
      }
    },
    // 导出excel
    async output() {
      let loginUser = getLoginUser();
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        storeCode: this.storeCode,
        exportId: loginUser.exportId
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (!this.isArray(searchCondition.date) || searchCondition.date.length < 2) {
        this.$message({
          type: "warning",
          message: "请选择销售时间"
        });
        return;
      }
      searchCondition.startDate = searchCondition.date[0];
      searchCondition.endDate = searchCondition.date[1];
      Object.assign(params, searchCondition);

      const { result } = await this.$store.dispatch("exportGjpPosOrderDivide", params);
      this.saveFile(result);
    },
    closeConfigShow(data) {
      const { show, doRefresh, tableHeaders} = data;
      this.actuallyPaymentAmountConfigShow = show;
      this.tableHeaders = this.allTableHeaders.filter(v => tableHeaders.indexOf(v.prop) > -1);
      if (doRefresh) {
        this.showOrderInfo = true;
        this.count = 0;
        this.sums = [];
        this.summartResult = {};
        this.clacGjpPosOrderDivideSummary();
        this.queryList();
      }
    },
    doConfigActuallyPaymentAmount() {
      this.actuallyPaymentAmountConfigShow = true;
    },
    updatedSummary() {
      this.$nextTick(() => {
        this.$refs.table && this.$refs.table.doLayout();
        this.footerTr = this.$refs.table.$el.querySelector('.el-table__footer-wrapper tr').children;
        const nodeList = this.footerTr;
        for (let i = 0; i < nodeList.length; i++ ){
          if (nodeList[i].children[0]) {
            if (Number(nodeList[i].children[0].textContent)) {
              nodeList[i].children[0].setAttribute('title', nodeList[i].children[0].textContent)
            }
          }
        }
      })
    },
    getSummaries(param, callback) {
      if (this.isArray(this.sums) && this.sums.length > 0) {
        callback(this.sums);
      }

      if (Object.keys(this.summartResult).length === 0) {
        callback(this.sums);
      }
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        switch (column.label) {
          case "商品数量":
            sums[index] = this.summartResult.goodsNum;
              break;
          case "零售额":
            sums[index] = ToFixed(this.summartResult.goodsRetailAmount || 0, 2);
            break;
          case "促销优惠":
            sums[index] = ToFixed(this.summartResult.pmDivideAmount || 0, 2);
            break;
          case "优惠券抵扣":
            sums[index] = ToFixed(this.summartResult.couponDivideAmount || 0, 2);
            break;
          case "会员优惠":
            let pmMember = this.summartResult.pmMemberpriceDivideAmount || 0;
            let member = this.summartResult.memberpriceDivideAmount || 0;
            sums[index] = ToFixed(pmMember + member, 2);
            break;
          case "改价优惠":
            sums[index] = ToFixed(this.summartResult.changePriceAmount || 0, 2);
            break;
          case "储值卡支付":
            sums[index] = ToFixed(this.summartResult.prepayDivideAmount || 0, 2);
            break;
          case "金豆支付":
            sums[index] = ToFixed(this.summartResult.goldbeanAmount || 0, 2);
            break;
          case "成交金额":
            sums[index] = ToFixed(this.summartResult.paymentNoCouponAmount || 0, 2);
            break;
          case "订单原价":
            sums[index] = ToFixed(this.summartResult.goodsRetailAmount || 0, 2);
            break;
          case "订单成交金额":
            sums[index] = ToFixed(this.summartResult.paymentNoCouponAmount || 0, 2);
            break;
          case "实付金额":
            sums[index] = ToFixed(this.summartResult.paymentConfigAmount || 0, 2);
            break;
          case "抹零":
            sums[index] = ToFixed(this.summartResult.roundDownAmount || 0, 2);
            break;
          default:
            sums[index] = '';
            break;
        }
      });
      this.sums = sums;
      // this.updatedSummary();

      callback(this.sums);
    },
    async clacGjpPosOrderDivideSummary() {
      const params = {
        storeCode: this.storeCode
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (!this.isArray(searchCondition.date) || searchCondition.date.length < 2) {
        this.$message({
          type: "warning",
          message: "请选择销售时间"
        });
        return;
      }
      searchCondition.startDate = searchCondition.date[0];
      searchCondition.endDate = searchCondition.date[1];
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch("getGjpPosGoodsDivideSummary", params);
      this.summartResult = result;
    },
    filterGuider(val) {
      this.searchCondition.workNum = val;
      if (val) {
        this.guiderList = this.allGuiderList.filter((item) => {
          return item.fullname.indexOf(val) > -1 || item.namepy.toLowerCase().indexOf(val.toLowerCase()) > -1 || item.tel.indexOf(val) > -1
        });
      } else {
        this.guiderList = this.allGuiderList;
      }
    },
    async queryGjpGuiderList() {
      let params = {
        storeCode: this.storeCode,
      }
      const { result } = await this.$store.dispatch("queryGjpGuiderList", params);
      this.guiderList = result;
      this.allGuiderList = result;
    },
    filterBrand(val) {
      this.searchCondition.brandId = val;
      if (val) {
        this.brandList = this.AllBrandList.filter((item) => {
          return item.fullname.indexOf(val) > -1 || item.namepy.toLowerCase().indexOf(val.toLowerCase()) > -1
        });
      } else {
        this.brandList = this.AllBrandList;
      }
    },
    async queryGjpBrandList() {
      let params = {
        storeCode: this.storeCode,
      }
      const { result } = await this.$store.dispatch("queryGjpBrandList", params);
      this.brandList = JSON.parse(JSON.stringify(result));
      this.AllBrandList = JSON.parse(JSON.stringify(result));
    },
    async recount(row) {
      console.log("recount")
      let params = {
        erpOrderId: row.erpOrderId,
        storeCode: this.storeCode,
      };
      await this.$store.dispatch("caclGjpPosOrderDivideJob", params);
      this.$message({
        message: "计算完成，正在查询!",
        type: "success"
      });
      this.showOrderInfo = true;
      this.sums = [];
      this.summartResult = {};
      this.clacGjpPosOrderDivideSummary();
      this.queryList();
    },
    async queryShopList() {
      let params = {
        storeCode: this.storeCode,
      }
      const { result } = await this.$store.dispatch("queryGjpShopList", params);
      this.shopList = JSON.parse(JSON.stringify(result));
    },
    //合并单元格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.mergeLabelList.indexOf(column.label) > -1) {
        return {
          rowspan: row.rowspan,
          colspan: 1
        };
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    search() {
      this.showOrderInfo = true;
      this.count = 0;
      this.sums = [];
      this.summartResult = {};
      this.currentPage = 1;
      this.clacGjpPosOrderDivideSummary();
      this.queryList();
      this.$store.commit("querySearchConditionState", this.searchCondition);
    },
    showDataHandle() {
      let tempList = [];
      let showRecords = JSON.parse(JSON.stringify(this.allRecords));

      showRecords.forEach((v, i) => {
        //剔除品类
        if (this.isArray(this.searchCondition.categoryIdList) && this.searchCondition.categoryIdList.length > 0) {
          v.goodsList = v.goodsList.filter(goods => {
            for (let j = 0; j < this.searchCondition.categoryIdList.length; j++) {
              if (goods.erpCategoryId.indexOf(this.searchCondition.categoryIdList[j]) > -1) {
                return true;
              }
            }
            return false;
          });
          this.showOrderInfo = false;
        }
        //剔除品牌
        if (this.searchCondition.brandId) {
          v.goodsList = v.goodsList.filter(goods => goods.erpBrandId.indexOf(this.searchCondition.brandId) > -1);
          this.showOrderInfo = false;
        }
        //剔除货号
        if (this.searchCondition.goodsSn) {
          v.goodsList = v.goodsList.filter(goods => goods.goodsSn.indexOf(this.searchCondition.goodsSn) > -1);
          this.showOrderInfo = false;
        }

        let erpShopName = "";
        let orderPayAmount = 0;
        let orderRetailAmount = 0;
        let saleDate = "";
        let orderSourceType = "";
        let roundDownAmount = 0;
        let goldbeanDivide = 0;
        if (v.gjpOrderPos) {
          erpShopName = v.gjpOrderPos.erpShopName;
          orderPayAmount = v.gjpOrderPos.payNoCouponAmount || 0;
          orderRetailAmount = v.gjpOrderPos.retailAmount;
          saleDate = v.gjpOrderPos.saleTime;
          orderSourceType = v.gjpOrderPos.orderSourceType;
          roundDownAmount = v.gjpOrderPos.roundDownAmount || 0;
          goldbeanDivide = v.gjpOrderPos.goldbeanAmount || 0;
        }
        if (v.goodsList && v.goodsList.length > 0) {
          v.goodsList.forEach((goods, index) => {
            if (index == 0) {
              goods.rowspan = v.goodsList.length;
              goods.nosort = i + (this.currentPage - 1) * this.pageSize + 1;
            } else {
              goods.rowspan = 0;
              goods.nosort = i + (this.currentPage - 1) * this.pageSize + 1;
            }
            //促销金额计算
            let pmDivide = 0;
            let pmName = "";
            let pmType = "";
            let pmmemberAmount = 0;
            if (v.pmDivideDetailPosList && v.pmDivideDetailPosList.length > 0) {
              v.pmDivideDetailPosList.forEach(pm => {
                if (goods.skuId === pm.skuId) {
                  pmDivide = ToFixed(pmDivide + pm.pmDivideAmount, 2);

                  //会员促销优惠
                  if (pm.memberAmount && pm.memberAmount > 0) {
                    pmmemberAmount = ToFixed(pmmemberAmount + pm.memberAmount, 2);
                  }

                  //促销名称
                  if (pmName) {
                    if (pmName.indexOf(pm.pmName) < 0) {
                      pmName = pmName + "," + pm.pmName;
                    }
                  } else {
                    pmName = pm.pmName;
                  }
                  //促销方式
                  if (pmType) {
                    if (pmType.indexOf(pm.pmType) < 0) {
                      pmType = pmType + "," + pm.pmType;
                    }
                  } else {
                    pmType = pm.pmType;
                  }
                }
              });
            }

            //优惠券金额计算
            let couponDivide = ToFixed(goods.payCouponAmount || 0, 2);
            // if (v.couponDivideDetailPosList && v.couponDivideDetailPosList.length > 0) {
            //   v.couponDivideDetailPosList.forEach(coupon => {
            //     if (goods.goodsSn === coupon.goodsSn) {
            //       couponDivide = ToFixed(couponDivide + coupon.couponDivideAmount, 2);
            //     }
            //   });
            // }

            //会员价优惠金额计算
            let memberpriceDivide = 0;
            if (v.memberpriceDivideDetailPosList && v.memberpriceDivideDetailPosList.length > 0) {
              v.memberpriceDivideDetailPosList.forEach(memberprice => {
                if (goods.skuId === memberprice.skuId) {
                  memberpriceDivide = ToFixed(memberpriceDivide + memberprice.memberpriceDivideAmount, 2);
                }
              });
            }

            //储值卡金额计算
            let prepayDivide = 0;
            if (v.prepayDivideDetailPosList && v.prepayDivideDetailPosList.length > 0) {
              v.prepayDivideDetailPosList.forEach(pre => {
                if (goods.skuId === pre.skuId) {
                  prepayDivide = ToFixed(prepayDivide + pre.prepayDivideAmount, 2);
                }
              });
            }

            //金豆
            // let goldbeanDivide = 0;
            // if (v.goldbeanDivideDetailPosList && v.goldbeanDivideDetailPosList.length > 0) {
            //   v.goldbeanDivideDetailPosList.forEach(goldbean => {
            //     if (goods.skuId === goldbean.skuId) {
            //       goldbeanDivide = ToFixed(goldbeanDivide + goldbean.goldbeanDivideAmount, 2);
            //     }
            //   });
            // }

            let memberpriceDivideAmount = goods.memberpriceDivideAmount || 0;
            let pmMemberAmount = goods.pmMemberAmount || 0;

                //促销
            goods.pmDivideDetailPosShow = pmDivide;
            //促销名称
            goods.pmNameDetailPosShow = pmName;
            //促销方式
            goods.pmTypeDetailPosShow = pmType;
            //优惠券
            goods.prepayDivideDetailPosShow = couponDivide;
            //会员优惠
            goods.memberpriceDivideDetailPosShow = ToFixed(memberpriceDivide + pmmemberAmount, 2);
            goods.memberDivideAmountTotal = ToFixed(memberpriceDivideAmount + pmMemberAmount, 2);
            //储值卡
            goods.prepayDivideDetailShow = prepayDivide;
            //金豆
            goods.goldbeanDivideDetailShow = goldbeanDivide;
            goods.receiptSn = v.receiptSn;
            goods.orderSourceType = orderSourceType;
            goods.totalActuallyPaymentAmount = v.totalActuallyPaymentAmount || 0;
            goods.totalGoldbeanDividDivideAmount = ToFixed(goldbeanDivide || 0, 2);
            goods.totalPrepayDivideAmount = v.totalPrepayDivideAmount || 0;
            goods.saleDate = saleDate;
            goods.erpOrderId = v.erpOrderIdStr;
            goods.erpShopName = erpShopName;
            goods.orderPayAmount = orderPayAmount;
            goods.orderRetailAmount = orderRetailAmount;
            goods.roundDownAmount = roundDownAmount;

            //计算改价
            goods.changePriceAmount = goods.changePriceAmount || 0;
            let showTip = goods.changePriceAmount;
            if (goods.changePriceAmount && goods.changePriceAmount != 0) {
              showTip = "改价金额:" + showTip + ",改价人:" + goods.changePriceName + ",备注:" + goods.changePriceComment;
            }
            goods.showTip = showTip;

            goods.goodsType = goods.goodsType == 'gift' ? "赠品" : "销售";
            goods.orderSourceType = goods.orderSourceType == 'erp' ? "线下" : "线上";

            let erpColorName = "";
            if (goods.erpColorName && goods.erpSizeName) {
              erpColorName = goods.erpColorName + "," + goods.erpSizeName;
            } else if (goods.erpColorName) {
              erpColorName = goods.erpColorName;
            } else if (goods.erpSizeName) {
              erpColorName = goods.erpSizeName;
            }
            goods.erpColorName = erpColorName;

            tempList.push(goods);
          });
        } else {
          tempList.push({
            receiptSn: v.receiptSn,
            orderSourceType: orderSourceType,
            totalActuallyPaymentAmount: v.totalActuallyPaymentAmount || 0,
            totalGoldbeanDividDivideAmount: v.totalGoldbeanDividDivideAmount || 0,
            totalPrepayDivideAmount: v.totalPrepayDivideAmount || 0,
            saleDate: saleDate,
            erpOrderId: v.erpOrderIdStr,
            erpShopName: erpShopName,
            orderPayAmount: orderPayAmount,
            orderRetailAmount: orderRetailAmount,
            roundDownAmount: roundDownAmount,
            rowspan: 1,
            nosort: i + (this.currentPage - 1) * this.pageSize + 1,
          });
        }

      });
      this.list = tempList;
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        storeCode: this.storeCode
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (!this.isArray(searchCondition.date) || searchCondition.date.length < 2) {
        this.$message({
          type: "warning",
          message: "请选择销售时间"
        });
        return;
      }
      searchCondition.startDate = searchCondition.date[0];
      searchCondition.endDate = searchCondition.date[1];
      Object.assign(params, searchCondition);

      //判断是否隐藏数据
      if ((this.isArray(this.searchCondition.categoryIdList) && this.searchCondition.categoryIdList.length > 0)
        || this.searchCondition.brandId || this.searchCondition.goodsSn) {
        let hideList = ["订单原价", "储值卡支付", "金豆支付", "实付金额", "抹零", "订单成交金额"];
        this.tableHeaders = this.tableHeaders.filter(v => hideList.indexOf(v.label) < 0);
      }

      const { code, result } = await this.$store.dispatch("queryOrderDivideDetails", params);
      if (code === 200) {
        if (result) {
          const { total, records } = result;
          this.total = total;
          this.allRecords = JSON.parse(JSON.stringify(records));
          this.showDataHandle();
        } else {
          this.list = [];
        }
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
  },
};
</script>

<style scoped lang="scss">
.bg {
  padding: 20px;
  background: #fff;
}
.table-header-wrapper {
  white-space: nowrap;
  text-overflow:ellipsis;
}

/deep/.el-table .el-table__footer-wrapper .cell{
  white-space: nowrap;
  text-overflow:ellipsis;
}

///deep/.el-table .el-table__footer-wrapper tr{
//  td:nth-child(16),td:nth-child(17),td:nth-child(18),td:nth-child(19) {
//    color: #E60E6D;
//  }
//}
///deep/.el-table .el-table__fixed-footer-wrapper tr{
//  td:nth-child(16),td:nth-child(17),td:nth-child(18),td:nth-child(19) {
//    color: #E60E6D;
//  }
//}
/deep/.el-table .el-table__fixed-footer-wrapper .cell{
  white-space: nowrap;
  text-overflow:ellipsis;
}
</style>
